import { useTheme } from '@/contexts/ThemeContext';
import type { ReactNode } from 'react';

export interface LuxModalFooterProps {
  /** Contenu du footer (boutons, etc.) */
  children: ReactNode;
  /** Alignement du contenu */
  align?: 'left' | 'center' | 'right';
  /** Classes CSS additionnelles */
  className?: string;
}

export function LuxModalFooter({ children, align = 'right', className = '' }: LuxModalFooterProps) {
  const { resolvedTheme } = useTheme();
  const alignClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }[align];
  const borderClass = resolvedTheme === 'dark' ? 'border-slate-700' : 'border-gray-200';

  return (
    <div
      className={`px-6 py-4 rounded-b-lg border-t modal-footer-gradient ${borderClass} ${className}`}
      data-lux-modal-footer
    >
      <div className={`flex items-center gap-3 ${alignClass}`}>{children}</div>
    </div>
  );
}
